(function () {
  'use strict';

  var ROOT_SELECTOR = '[id^="lbx-product-"]';
  var BUTTON_SELECTOR = '[data-lbx-option-button]';
  var scheduled = false;
  var runCount = 0;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function isColorBlock(block) {
    if (!block) return false;
    if (block.getAttribute('data-lbx-v30-role') === 'color') return true;
    if (block.getAttribute('data-lbx-v29-role') === 'color') return true;
    if (block.classList && block.classList.contains('lbx-v29-color-role')) return true;
    if (block.querySelector && block.querySelector('.lbx-color-list')) return true;

    var label = block.querySelector && block.querySelector('.lbx-option-label');
    var text = normalize(label ? label.textContent : '');
    return text.indexOf('color') !== -1 ||
      text.indexOf('farbe') !== -1 ||
      text.indexOf('colour') !== -1 ||
      text.indexOf('couleur') !== -1 ||
      text.indexOf('colore') !== -1 ||
      text.indexOf('cor') !== -1;
  }

  function unlockButton(button) {
    if (!button) return;

    // Do not dispatch events or force variant selection here. Only remove UI locks
    // from colour swatches. This avoids the endless variant re-render loop that
    // blocked the product page in V35.
    button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('data-disabled');
    button.removeAttribute('data-unavailable');
    button.classList.remove('is-disabled', 'disabled', 'is-unavailable', 'unavailable');
    button.classList.add('lbx-v37-color-selectable');
  }

  function apply(root) {
    root = root || document;
    var scope = root.querySelectorAll ? root : document;
    var blocks = Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR + ' .lbx-option-block'));

    blocks.forEach(function (block) {
      if (!isColorBlock(block)) return;
      block.setAttribute('data-lbx-v37-color-unlocked', 'true');
      Array.prototype.slice.call(block.querySelectorAll(BUTTON_SELECTOR)).forEach(unlockButton);
    });
  }

  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      apply(root || document);
    }, 80);
  }

  function runStartupPasses() {
    [0, 120, 450, 1200, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        runCount += 1;
        apply(document);
      }, delay);
    });
  }

  function boot() {
    runStartupPasses();

    // Capture only the user's interaction with colour buttons. No MutationObserver
    // on attributes, no class-watching loop.
    ['pointerdown', 'touchstart', 'mousedown', 'click'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var button = event.target && event.target.closest && event.target.closest(BUTTON_SELECTOR);
        if (!button) return;
        var block = button.closest && button.closest('.lbx-option-block');
        if (!isColorBlock(block)) return;
        Array.prototype.slice.call(block.querySelectorAll(BUTTON_SELECTOR)).forEach(unlockButton);
        unlockButton(button);
      }, true);
    });

    // Safe rerender support: observe added nodes only. Do not observe attributes,
    // because removing disabled/classes inside the observer can retrigger itself.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        var needsRun = false;
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes && mutation.addedNodes.length) needsRun = true;
        });
        if (needsRun) schedule(document);
      });
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
